import React from "react"
import { type RouteObject, Navigate } from "react-router-dom"

import { RoutesPaths } from "../../../../constants/routes.ts"
import PortalCalendarPage from "../../../Portal/CalendarPage.tsx"
import PortalDocumentsPage from "../../../Portal/DocumentsPage.tsx"
import PortalHomePage from "../../../Portal/HomePage.tsx"
import PortalMessagesPage from "../../../Portal/MessagesPage.tsx"
import PortalPaymentsPage from "../../../Portal/PaymentsPage.tsx"
import PortalPhotosPage from "../../../Portal/PhotosPage.tsx"
import PortalProjectWorkspace from "../../../Portal/ProjectWorkspace/PortalProjectWorkspace.tsx"
import PortalProjectsPage from "../../../Portal/ProjectsPage.tsx"
import PortalSettingsPage from "../../../Portal/SettingsPage.tsx"

export const portalRoutes: RouteObject[] = [
  { path: "/portal", element: <Navigate to={RoutesPaths.portal.home} replace /> },
  { path: RoutesPaths.portal.home, element: <PortalHomePage /> },
  { path: RoutesPaths.portal.projects, element: <PortalProjectsPage /> },
  { path: RoutesPaths.portal.projectPattern, element: <PortalProjectWorkspace /> },
  { path: RoutesPaths.portal.documents, element: <PortalDocumentsPage /> },
  { path: RoutesPaths.portal.photos, element: <PortalPhotosPage /> },
  { path: RoutesPaths.portal.messages, element: <PortalMessagesPage /> },
  { path: RoutesPaths.portal.payments, element: <PortalPaymentsPage /> },
  { path: RoutesPaths.portal.calendar, element: <PortalCalendarPage /> },
  { path: RoutesPaths.portal.settings, element: <PortalSettingsPage /> },
  // Superseded by Settings → Account & security.
  { path: RoutesPaths.portal.account, element: <Navigate to={RoutesPaths.portal.settings} replace /> }
]
